import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Stepper from '@mui/material/Stepper'
import { PDFDownloadLink } from '@react-pdf/renderer'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import { createTransfer, getasset } from '../../../Api/index'
import { sendAnalyticsEvent } from '../../../analytics'
import DashboardLayout from '../../../components/ui/DashboardLayout'
import Loading from '../../../components/ui/Loading'
import { BackButton, Copy } from '../../../components/ui/Swicons'
import { STEPS, devURL, titleCase } from '../../../utils'
import Receipt from './Receipt'

export default function TransactionDetails() {
  const token = localStorage.getItem('swToken')
  const [loader, isLoading] = useState(true)
  const [pdfLoad, setpdfLoad] = useState(true)
  const [promoCode, setPromoCode] = useState('')
  const [showPromoCode, setShowPromoCode] = useState(true)
  const [recentID, setRecentID] = useState('')
  const [showTransferDetails, setShowTransferDetails] = useState(false)
  const [recipientId, setRecipientId] = useState()
  const [sentAmount, setSentAmount] = useState()
  const [transactionDetails, setTransactionDetails] = useState({})
  const [stepperState, setStepperState] = useState(1)
  const [Asset, setAsset] = useState()
  const [DfnswalletId, setDfnswalletId] = useState()
  const { id } = useParams()
  const navigate = useNavigate()
  let circleCommonClasses = 'h-1 w-1 bg-current rounded-full'

  useEffect(() => {
    isLoading(true)
    getUserProfileData()
  }, [])

  const dfns_transfer = async () => {
    isLoading(true)
    try {
      await createTransfer(transactionDetails._id, DfnswalletId)
      if (id === 'recent') {
        getLatestTransaction()
      } else {
        setRecentID(id)
        getTransferByID()
      }
    } catch (err) {
      isLoading(false)
      if (err.response.status === 401) {
        localStorage.removeItem('swToken')
        return navigate('/Login')
      }
      sendAnalyticsEvent('error', {
        category: 'DFNS',
        action: 'dfns_transfer',
        label: 'dfns_transfer',
      })
      toast.error('Something went wrong')
      console.log(err)
    }
  }
  useEffect(() => {
    if (id === 'recent') {
      getLatestTransaction()
    } else {
      setRecentID(id)
      getTransferByID()
    }
  }, [id])

  const getUserProfileData = () => {
    axios
      .get(`${devURL}/user/get-user-info`, {
        headers: { token: token },
      })
      .then((res) => {
        if (res.data) {
          setDfnswalletId(res.data.dfns_wallet_id)
          getasset(res.data.dfns_wallet_id)
            .then((result) => {
              setAsset(result)
            })
            .catch((error) => {
              console.error('Error fetching asset:', error)
            })
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    if (transactionDetails) {
      if (transactionDetails.is_deleted) {
        setStepperState(0)
      } else if (transactionDetails.is_completed) {
        setStepperState(5)
      } else if (
        transactionDetails.money_received &&
        transactionDetails.is_vda_credited &&
        transactionDetails.is_vda_debited
      ) {
        setStepperState(4)
      } else if (
        transactionDetails.money_received &&
        transactionDetails.is_vda_credited
      ) {
        setStepperState(3)
      } else if (transactionDetails.user_deposit_confirmed) {
        setStepperState(2)
      } else {
        setStepperState(1)
      }
    }
  }, [transactionDetails])

  const handlePromoCode = (e) => {
    e.preventDefault()
    if (promoCode === '') {
      toast.error('Please enter promo code')
      return
    }
    if (id == 'recent') {
      axios
        .post(
          `${devURL}/transfer/apply-promo/${recentID}`,
          { code: promoCode },
          {
            headers: { token: token },
          }
        )
        .then((res) => {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Promo code applied!',
            showConfirmButton: false,
            timer: 1500,
          })
          getLatestTransaction()
          setShowPromoCode(false)
        })
        .catch((err) => {
          toast.error(err.response.data.message)
          console.log(err)
        })
    } else {
      axios
        .post(
          `${devURL}/transfer/apply-promo/${id}`,
          { code: promoCode },
          {
            headers: { token: token },
          }
        )
        .then((res) => {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Promo code applied!',
            showConfirmButton: false,
            timer: 1500,
          })
          getTransferByID()
          setShowPromoCode(false)
        })
        .catch((err) => {
          toast.error(err.response.data.message)
          console.log(err)
        })
    }
  }

  const getLatestTransaction = () => {
    axios
      .get(`${devURL}/transfer/get`, {
        headers: { token: token },
      })
      .then((res) => {
        if (res.data.status) {
          setRecentID(res.data.transfers[0]['_id'])

          axios
            .post(
              `${devURL}/transfer/deposit`,
              { id: res.data.transfers[0]['_id'] },
              { headers: { token: token } }
            )
            .then((transres) => {
              if (transres.status) {
                setTransactionDetails({
                  ...transres.data.data,
                  ...res.data.transfers[0],
                })
                setSentAmount(transres.data.data.sent_amount)
                setRecipientId(res.data.recipient_id)
                isLoading(false)
              }
            })
            .catch((err) => {
              console.log(err)
              if (err.response.status === 401) {
                localStorage.removeItem('swToken')
                return navigate('/Login')
              }
              if (
                err.response &&
                err.response.data &&
                err.response.data.errorMessage
              ) {
                toast.error(err.response.data.errorMessage)
              }
            })
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }
  const getTransferByID = async () => {
    try {
      let res = await axios.get(`${devURL}/transfer/get-by-id/${id}`, {
        headers: { token: token },
      })
      let bankdetails = await axios.post(
        `${devURL}/transfer/deposit`,
        { id: id },
        { headers: { token: token } }
      )
      isLoading(false)
      setpdfLoad(false)
      setTransactionDetails({ ...bankdetails.data.data, ...res.data.data })
      setSentAmount(res.data.data.sent_amount)
      setRecipientId(res.data.data.recipient_id)
    } catch (e) {
      console.error(e)
      if (e.response.status === 401) {
        localStorage.removeItem('swToken')
        return navigate('/Login')
      }
      toast.error('Something went wrong')
    }
  }

  const handelDelete = async (e) => {
    e.preventDefault()
    let result = await Swal.fire({
      title: 'Cancel transfer?',
      text: 'Do you really want to cancel transfer?',
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes, Cancel',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#33d',
      cancelButtonText: "No, Don't Cancel",
    })
    if (result.isDismissed) {
      return
    } else if (result.isConfirmed) {
      try {
        let res = await axios.patch(
          `${devURL}/transfer/update`,
          {
            transfer_id: recentID,
            is_deleted: true,
          },
          {
            headers: { token },
          }
        )
        if (res.status < 400) {
          toast.success('Transaction deleted successfully')
          navigate('/Transaction-List')
        }
      } catch (e) {
        if (e.response.status === 401) {
          toast.error('Session expired please login again')
          localStorage.removeItem('swToken')
          return navigate('/Login')
        }
        console.log(e)
        toast.error('Something went wrong')
      }
    }
  }

  const handelSent = async (e) => {
    e.preventDefault()
    let result = await Swal.fire({
      title: 'Have you transferred funds to ScopeX?',
      text: `Can you verify the transfer of ${transactionDetails.sent_amount} ${transactionDetails.src_currency} to ScopeX's account with deposit code ${transactionDetails.deposit_code}?`,
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      confirmButtonColor: '#2878bb',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
    })
    if (result.isDismissed) {
      return
    } else if (result.isConfirmed) {
      try {
        let res = await axios.patch(
          `${devURL}/transfer/update`,
          {
            transfer_id: recentID,
            user_deposit_confirmed: true,
          },
          {
            headers: { token },
          }
        )
        if (res.status < 400) {
          setStepperState(2)
          toast.success('Deposit confirmed successfully')
          setTransactionDetails((val) => ({
            ...val,
            user_deposit_confirmed: true,
          }))
        }
      } catch (e) {
        console.log(e)
        toast.error('Something went wrong')
      }
    }
  }

  return (
    <DashboardLayout>
      <button onClick={() => navigate(-1)} className='hidden lg:block'>
        <BackButton />
      </button>

      <div className='lg:p-12 ml-2 pt-4 px-4'>
        <Stepper activeStep={stepperState} alternativeLabel>
          {STEPS.map((label) => (
            <Step key={label}>
              <StepLabel>
                <div className='text-xs lg:text-lg'>{label}</div>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      <div className='page-title text-xl font-bold mt-6 lg:mt-0 lg:-ml-0'>
        <p>Deposit Transfer Detail</p>
      </div>

      {loader ? (
        <Loading />
      ) : (
        <div className='p-8 flex flex-col  mt-6 items-center'>
          <div className='font-semibold flex flex-col gap-4 text-base sw-shadow p-8 lg:p-12 rounded-xl ml-4 lg:ml-0'>
            {transactionDetails.is_deleted ? (
              <>
                <div className='bg-red-300 text-center px-12 rounded-md py-2'>
                  <h2 className='font-bold text-lg'>Transfer is cancelled</h2>
                </div>

                <div className='grid grid-cols-2 gap-8'>
                  <div>
                    <p className='text-xs lg:text-base py-1'>
                      Recipient Name:{' '}
                    </p>
                    <p className='text-xs lg:text-base py-1'>You send: </p>
                    <p className='text-xs lg:text-base py-1'>
                      Recipient receives:{' '}
                    </p>
                    <p className='text-xs lg:text-base py-1'>Exchange rate:</p>
                    <p className='text-xs lg:text-base py-1'>Our fee:</p>
                    <p className='text-xs lg:text-base py-1'>Transfer ID:</p>
                  </div>
                  <div>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {titleCase(transactionDetails.recipient_name)}
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.sent_amount} EUR
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.received_amount} INR
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.rate.toFixed(2)}
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.fee}
                    </p>
                    <div className='flex'>
                      <p className='font-normal text-xs lg:text-base py-1 break-words'>
                        {transactionDetails.transaction_id}
                      </p>
                      <CopyToClipboard
                        text={transactionDetails.transaction_id}
                        onCopy={() => toast.success('Copied!')}
                      >
                        <button className='pl-4'>
                          <Copy />
                        </button>
                      </CopyToClipboard>
                    </div>
                  </div>
                </div>
              </>
            ) : transactionDetails.is_completed ? (
              <>
                <div className='bg-green-300 text-center px-12 rounded-md py-2 '>
                  <h2 className='font-bold text-lg'>Transfer is completed</h2>
                </div>

                <div className='grid grid-cols-2 gap-8'>
                  <div>
                    <p className='text-xs lg:text-base py-1'>
                      Recipient Name:{' '}
                    </p>
                    <p className='text-xs lg:text-base py-1'>You sent : </p>
                    <p className='text-xs lg:text-base py-1'>
                      Recipient received:{' '}
                    </p>
                    <p className='text-xs lg:text-base py-1'>Exchange rate:</p>
                    <p className='text-xs lg:text-base py-1'>Our fee:</p>
                    <p className='text-xs lg:text-base py-1'>Transfer ID:</p>
                  </div>
                  <div>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {titleCase(transactionDetails.recipient_name)}
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.sent_amount} EUR
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.received_amount} INR
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.rate.toFixed(2)}
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.fee}
                    </p>
                    <div className='flex'>
                      <p className='font-normal text-xs lg:text-base py-1 break-words'>
                        {transactionDetails.transaction_id}
                      </p>
                      <CopyToClipboard
                        text={transactionDetails.transaction_id}
                        onCopy={() => toast.success('Copied!')}
                      >
                        <button className='pl-4'>
                          <Copy />
                        </button>
                      </CopyToClipboard>
                    </div>
                  </div>
                </div>
                <PDFDownloadLink
                  document={<Receipt transfer={transactionDetails} />}
                  fileName={transactionDetails.transaction_id}
                  className='flex justify-center border-2 bg-themeColor text-white lg:mx-24 rounded-md py-2 px-4 mt-2'
                >
                  {({ blob, url, loading, error }) =>
                    pdfLoad ? 'Loading..' : 'Download reciept'
                  }
                </PDFDownloadLink>
              </>
            ) : // : transactionDetails.raise_issue ? (
            //   <>
            //     <div className="bg-orange-300 text-center px-12 rounded-md py-2">
            //       <h2 className="font-bold text-lg">
            //         ScopeX is verifying your transfer.
            //       </h2>
            //     </div>

            //     <div className="grid grid-cols-2 gap-8">
            //       <div>
            //         <p className="text-xs lg:text-base py-1">
            //           Recipient Name:{" "}
            //         </p>
            //         <p className="text-xs lg:text-base py-1">You send: </p>
            //         <p className="text-xs lg:text-base py-1">
            //           Recipient receives:{" "}
            //         </p>
            //         <p className="text-xs lg:text-base py-1">Exchange rate:</p>
            //         <p className="text-xs lg:text-base py-1">Our fee:</p>
            //         <p className="text-xs lg:text-base py-1">Transfer ID:</p>
            //       </div>
            //       <div>
            //         <p className="font-normal text-xs lg:text-base py-1">
            //           {titleCase(transactionDetails.recipient_name)}
            //         </p>
            //         <p className="font-normal text-xs lg:text-base py-1">
            //           {transactionDetails.sent_amount} EUR
            //         </p>
            //         <p className="font-normal text-xs lg:text-base py-1">
            //           {transactionDetails.received_amount.toFixed(2)} INR
            //         </p>
            //         <p className="font-normal text-xs lg:text-base py-1">
            //           {transactionDetails.rate.toFixed(2)}
            //         </p>
            //         <p className="font-normal text-xs lg:text-base py-1">
            //           {transactionDetails.fee}
            //         </p>
            //         <div className="flex">
            //           <p className="font-normal text-xs lg:text-base py-1 break-words">
            //             {transactionDetails.transaction_id}
            //           </p>
            //           <CopyToClipboard
            //             text={transactionDetails.transaction_id}
            //             onCopy={() => toast.success("Copied!")}
            //           >
            //             <button className="pl-4">
            //               <Copy />
            //             </button>
            //           </CopyToClipboard>
            //         </div>
            //       </div>
            //     </div>
            //   </>
            // )
            transactionDetails.money_received &&
              transactionDetails.is_vda_credited ? (
              <>
                <div className='bg-blue-300 text-center px-12 rounded-md py-2'>
                  {!transactionDetails.is_vda_debited ? (
                    <h2 className='font-bold text-lg'>
                      Approve your transfer{' '}
                    </h2>
                  ) : (
                    <div className='flex'>
                      <h2 className='font-bold text-lg'>
                        Transferring funds to recipient
                      </h2>
                      <div className='flex mt-4 pl-1'>
                        <div
                          className={`${circleCommonClasses} mr-1 animate-bounce`}
                        ></div>
                        <div
                          className={`${circleCommonClasses} mr-1 animate-bounce200`}
                        ></div>
                        <div
                          className={`${circleCommonClasses} animate-bounce400`}
                        ></div>
                      </div>
                    </div>
                  )}
                </div>

                <div className='grid grid-cols-2 gap-8'>
                  <div>
                    <p className='text-xs lg:text-base py-1'>
                      Recipient Name:{' '}
                    </p>
                    <p className='text-xs lg:text-base py-1'>You sent: </p>
                    <p className='text-xs lg:text-base py-1'>
                      Recipient receives:{' '}
                    </p>
                    <p className='text-xs lg:text-base py-1'>Exchange rate:</p>
                    <p className='text-xs lg:text-base py-1'>Our fee:</p>
                    <p className='text-xs lg:text-base py-1'>Transfer ID:</p>
                  </div>
                  <div>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {titleCase(transactionDetails.recipient_name)}
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.sent_amount} EUR
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.received_amount} INR
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.rate.toFixed(2)}
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.fee}
                    </p>
                    <div className='flex'>
                      <p className='font-normal text-xs lg:text-base py-1 break-words'>
                        {transactionDetails.transaction_id}
                      </p>
                      <CopyToClipboard
                        text={transactionDetails.transaction_id}
                        onCopy={() => toast.success('Copied!')}
                      >
                        <button className='pl-4'>
                          <Copy />
                        </button>
                      </CopyToClipboard>
                    </div>
                  </div>
                </div>
                {!transactionDetails.is_vda_debited &&
                  transactionDetails.is_vda_credited && (
                    <div className='flex justify-center'>
                      <button
                        onClick={dfns_transfer}
                        className='group relative py-2 mt-2 px-4 w-1/2 ml-2 border border-transparent text-md font-semibold rounded-full text-white bg-themeColor hover:bg-themeHover'
                      >
                        Approve transfer
                      </button>
                    </div>
                  )}
              </>
            ) : transactionDetails.user_deposit_confirmed ? (
              <>
                <div className='bg-teal-200 text-center px-12 rounded-md py-2'>
                  <h2 className='font-bold text-lg'>
                    ScopeX will verify your transfer soon.
                  </h2>
                </div>

                <div className='grid grid-cols-2 gap-8'>
                  <div>
                    <p className='text-xs lg:text-base py-1'>
                      Recipient Name:{' '}
                    </p>
                    <p className='text-xs lg:text-base py-1'>You send : </p>
                    <p className='text-xs lg:text-base py-1'>
                      Recipient receives:{' '}
                    </p>
                    <p className='text-xs lg:text-base py-1'>Exchange rate:</p>
                    <p className='text-xs lg:text-base py-1'>Our fee:</p>
                    <p className='text-xs lg:text-base py-1'>Transfer ID:</p>
                  </div>
                  <div>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {titleCase(transactionDetails.recipient_name)}
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.sent_amount} EUR
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.received_amount.toFixed(2)} INR
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.rate.toFixed(2)}
                    </p>
                    <p className='font-normal text-xs lg:text-base py-1'>
                      {transactionDetails.fee}
                    </p>
                    <div className='flex'>
                      <p className='font-normal text-xs lg:text-base py-1 break-words'>
                        {transactionDetails.transaction_id}
                      </p>
                      <CopyToClipboard
                        text={transactionDetails.transaction_id}
                        onCopy={() => toast.success('Copied!')}
                      >
                        <button className='pl-4'>
                          <Copy />
                        </button>
                      </CopyToClipboard>
                    </div>
                  </div>
                </div>
                <button
                  className='py-2 px-4 mt-4 border-2 border-red-600 font-bold rounded-md text-red-600 bg-white hover:bg-red-600 hover:text-white'
                  onClick={handelDelete}
                >
                  Cancel Transfer
                </button>
              </>
            ) : (
              <>
                <div className='text-2xl font-bold text-center'>
                  Transfer Details
                </div>
                <div>
                  {transactionDetails?.discount?.promo ? null : (
                    <div>
                      <label className='text-gray-600 text-sm text-left font-bold mb-1'>
                        Promo Code
                        <span className='text-sm font-light italic pl-1'></span>
                      </label>
                      <div className='flex gap-2'>
                        <input
                          className='appearance-none relative block w-2/4 md:w-3/4 px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                          type='text'
                          onChange={(e) => setPromoCode(e.target.value)}
                          placeholder='Enter promo code'
                          value={promoCode}
                        />

                        <button
                          className='ml-2 bg-themeColor p-2 text-white font-medium rounded-md hover:bg-themeHover'
                          onClick={handlePromoCode}
                        >
                          Use code
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div className='text-center p-2 my-2 bg-blue-100 rounded-xl'>
                  {transactionDetails?.discount?.promo ? (
                    <p>Discount of 10 EUR applied!</p>
                  ) : (
                    <p>
                      Use code INDIA for 10 EUR off on transfers above 1000 EUR!
                    </p>
                  )}
                </div>
                <div className='flex flex-col items-center gap-3'>
                  {/* <button
                    className='w-full p-2 bg-themeColor text-white rounded'
                    onClick={() => {
                      navigate(`/checkout/${transactionDetails._id}`);
                    }}
                  >
                    Pay with iDEAL
                  </button>
                  <span>OR</span> */}

                  <button
                    className='w-full p-2 bg-themeColor text-white rounded'
                    onClick={() => setShowTransferDetails(true)}
                  >
                    Manually transfer using Instant SEPA
                  </button>
                </div>

                {showTransferDetails && (
                  <div>
                    {' '}
                    <div>
                      <label
                        htmlFor='name'
                        className='text-gray-600 text-sm text-left font-bold mb-1'
                      >
                        Name:
                      </label>
                      <div className='flex'>
                        <input
                          type='text'
                          name='name'
                          value={transactionDetails.entity_name}
                          className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                          readOnly
                        />
                        <CopyToClipboard
                          text={transactionDetails.entity_name}
                          onCopy={() => toast.success('Copied!')}
                        >
                          <button className='pl-2' data-test='copy'>
                            <Copy />
                          </button>
                        </CopyToClipboard>
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor='deposit code'
                        className='text-gray-600 text-sm text-left font-bold mb-1'
                      >
                        IBAN:
                      </label>
                      <div className='flex'>
                        <textarea
                          className=' appearance-none h-auto md:h-9 relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                          name='IBAN'
                          value={transactionDetails.IBAN}
                          readOnly
                          style={{ resize: 'none' }}
                        />
                        <CopyToClipboard
                          text={transactionDetails.IBAN}
                          onCopy={() => toast.success('Copied!')}
                        >
                          <button className='pl-2'>
                            <Copy />
                          </button>
                        </CopyToClipboard>
                      </div>
                    </div>
                    <div>
                      <div className='flex gap-4'>
                        <div>
                          <label className='text-gray-600 text-sm text-left font-bold mb-1'>
                            Amount to be sent (EUR)
                            <span className='text-sm font-light italic pl-1'></span>
                          </label>
                          <input
                            className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                            type='text'
                            value={sentAmount}
                            readOnly
                          />
                        </div>

                        <div>
                          <label className='text-gray-600 text-sm text-left font-bold mb-1'>
                            Recipient receives (INR)
                            <span className='text-sm font-light italic pl-1'></span>
                          </label>
                          <input
                            className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                            type='text'
                            value={transactionDetails.received_amount}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor='deposit code'
                        className='text-gray-600 text-sm text-left font-bold mb-1'
                      >
                        Deposit Code
                        <span className='text-sm font-light italic pl-1'>
                          (Use this code in comments while transferring)
                        </span>
                      </label>
                      <div className='flex'>
                        <input
                          className='appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm'
                          type='text'
                          name='deposit code'
                          data-test='deposit-code'
                          value={transactionDetails.deposit_code}
                          readOnly
                        />
                        <CopyToClipboard
                          text={transactionDetails.deposit_code}
                          onCopy={() => toast.success('Copied!')}
                        >
                          <button className='pl-2'>
                            <Copy />
                          </button>
                        </CopyToClipboard>
                      </div>
                    </div>
                  </div>
                )}

                <div className='flex justify-between pt-4'>
                  {transactionDetails?.user_deposit_confirmed ? null : (
                    <>
                      <button
                        className='py-2 px-4 border border-transparent font-medium rounded-md text-white bg-themeColor hover:bg-themeHover'
                        onClick={handelSent}
                      >
                        I have Paid
                      </button>
                      <button
                        className='py-2 px-4 border border-transparent font-medium rounded-md text-white bg-red-600 hover:bg-red-500'
                        onClick={handelDelete}
                      >
                        Cancel
                      </button>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </DashboardLayout>
  )
}
